"use client";

import React from "react";
import { FooterFields, File } from "@/types/contentful/footer"; // Import the type
import { Box, CircularProgress } from "@mui/material";
import HubspotEmbed from "@/components/forms/hubspot-embed";
import useHubspotEmbed from "@/hooks/forms/use-hubspot-embed";


interface DealsSignupProps {
  dealsSignUp: FooterFields[]; // Define the prop type
}

const DealsSignup: React.FC<DealsSignupProps> = ({ dealsSignUp }) => {

    const formId = dealsSignUp[0].dealsSignUp.fields.formId as unknown as string;
    const portalId = dealsSignUp[0].dealsSignUp.fields.portalId as unknown as string;
    const formName = dealsSignUp[0].dealsSignUp.fields.formName as unknown as string;
    const backgroundImage = dealsSignUp[0].backgroundImage.fields.file as unknown as File;

          const {
            dataLayerProps,
            isLoading,
            targetId
        } = useHubspotEmbed({
              formId,
              portalId,
              formName
        });

    
 return (
        <Box
            id="deals-signup-form"
            sx={{ 
            textAlign: "center", 
            padding: "2rem", 
            backgroundImage: `url(https:${backgroundImage.url})`,
            backgroundSize: "200% auto",
            position: "relative",
            minHeight: "245px", // Prevent layout shift during loading
            color: "common.white"
            }}>
            
            
            <div style={{
              fontSize: "3.75rem",
              fontWeight: 700,
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: 1.1,
              letterSpacing: "normal",
              color: "common.white",
              marginBottom: "1.5rem"
            }}>
              Get travel deals and news right to your inbox
            </div>

            {/* Always render the form container, but keep it hidden until fully styled */}
             <Box  id="hubspot-form"
                    sx={{ 
                        maxWidth: "500px", 
                        margin: "auto", 
                        marginTop: "1rem",
                        opacity: !isLoading ? 1 : 0,
                        transition: "opacity 0.3s ease-in-out" // Smooth fade-in
                      }}
              > 
                      <HubspotEmbed 
                          formId={formId} 
                          dataLayerProps={dataLayerProps}
                          targetId={targetId}
                      />
            </Box>

            {/* Simple loading indicator */}
                        {(isLoading) && (
                            <Box sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 2
                            }}>
                                <CircularProgress color="primary" />
                            </Box>
                        )}

            
        </Box>
    );
  
  
  
};

export default DealsSignup;